<template>
  <enfold>
    <div class="login-log">
      <enfold-ucd>
        <template slot="up">
          <div class="c-u-left flex-b-c">
            <div>
              <el-button size="mini" round type="primary" icon="el-icon-document" @click="exportExcel">{{$t('log.export')}}</el-button>
            </div>
            <div class="flex-b-c" style="margin-left: 32px; font-size: 14px">
              <span style="margin-right: 8px;">范围查询:</span>
              <el-date-picker v-model="date_pick" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" size="mini" class="margin-8" @change="changeTime"></el-date-picker>
            </div>
          </div>
          <div class="c-u-right">
            <!-- <div class="select">
							<el-select v-model="selectDate" filterable :placeholder="$t('log.selectDevice')" size="mini"
								v-loadmore="loadMore" @change="selectChange">
								<el-option v-for="(item,index) in options" :key="index" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div> -->
            <device-list @selectDevice="selectChange"></device-list>
            <div class="search">
              <div class="search_input">
                <el-input v-model="keyword" :placeholder="$t('review.enterKey')" size="mini">
                  <!-- <i slot="suffix" class="el-icon-close" style="margin-right: 5px;"></i> -->
                  <i slot="suffix" class="el-icon-search" @click="search"></i>
                </el-input>
              </div>
            </div>
          </div>
        </template>
        <template slot="center">
          <el-table :data="logList" style="width: 100%" v-loading="loading" height="100%">
            <el-table-column prop="device_name" :label="$t('terminal.deviceName')"></el-table-column>
            <el-table-column prop="device_sn" :label="$t('log.deviceSn')"></el-table-column>
            <el-table-column prop="group_name" :label="$t('terminal.structure')"></el-table-column>
            <el-table-column prop="title" :label="$t('terminal.types')"></el-table-column>
            <el-table-column prop="create_time" :label="$t('log.operateTime')" width="180" sortable></el-table-column>
          </el-table>
        </template>
        <template slot="down">
          <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
        </template>
      </enfold-ucd>
    </div>
    <export-dialog :exportDialogVisible="exportDialogVisible" :logList="logList" type="login" @changeShow="showAdd">
    </export-dialog>
  </enfold>
</template>

<script>
// const year = new Date().getFullYear();
// const month = new Date().getMonth();
// const date = new Date().getDate();
import EnfoldUcd from "@/components/basics/EnfoldUCD"
import Enfold from "@/components/basics/Enfold"
import pagination from '@/components/basics/Pagination'
import ExportDialog from './children/ExportDialog'
import DeviceList from './children/DeviceList'
import {
  mPagination
} from "@/components/basics/mixins";
export default {
  name: 'LoginlLog',
  mixins: [mPagination],
  components: {
    Enfold,
    EnfoldUcd,
    ExportDialog,
    pagination,
    DeviceList
    //FormDialog
  },
  data() {
    return {
      logType: 1,
      exportDialogVisible: false,
      logList: [],
      deviceList: [],
      loading: false,
      selectDate: '',
      selectDeviceId: '',
      date_pick: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 30), new Date()],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    showAdd() {
      this.exportDialogVisible = false;
      // if (data === 'false') {
      // 	this.exportDialogVisible = false
      // } else {
      // 	this.exportDialogVisible = true
      // }
    },
    changeTime(time) {
      if (!time) {
        this.date_pick = ['', ''];
      }
      // const [start, end] = time;
      // console.log(start.toLocaleString(), end.toLocaleString());
      // 
      this.getLogList();
    },
    openFilterDialog() {
      this.msgDialogVisible = true;
    },
    closeDialog(isConfirm) {
      if (isConfirm) {
        console.log("确定...")
      }
      this.msgDialogVisible = false;
    },
    getLogList(params) {
      this.loading = true;
      let log = {
        limit: this.limit,
        page: this.page,
        device_id: this.selectDate,
        key_word: this.keyword,
        group_ids: this.groupIds,
        startTime: this.date_pick[0].toLocaleString(),
        endTime: this.date_pick[1].toLocaleString(),
        ...params
      };
      this.$http.post("/admin/log/deviceLoginList", log, data => {
        this.logList = data.data ? data.data : [];
        this.current = parseInt(data.total); //获取数据的总条数
        this.loading = false;
      });
    },
    search() {
      this.getLogList();
      this.keyword = '';
    },
    currentChange(val) {
      this.page = val;
      this.getLogList();
    },
    dateChange() {
      console.log(this.date_pick);
    },
    exportExcel() {
      this.exportDialogVisible = true;
    },
    closeExportDialog(isConfirm) {
      if (isConfirm) {
        console.log("导出.....")
      }
      this.exportDialogVisible = false;
    },
    selectChange(id) {
      this.keyword = '';
      this.selectDate = id;
      this.getLogList();
    },
  },
  created() {
    console.log(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30));
    this.getLogList();
  }
}
</script>

<style lang="scss" scoped>
.login-log {
  height: 100%;

  .choose_button {
    margin-left: 50%;
  }

  .c-u-left {
    /deep/ .el-input__inner {
      // height: 30px;
      // line-height: 30px;
      border-radius: 15px;
    }
  }
  .c-u-right {
    width: 450px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .search {
    // flex-basis: 26%;
    display: flex;
    height: 100%;
    border-radius: 30px;
    // margin-right: -60%;
  }

  .datepick {
    flex-basis: 26%;
    display: flex;
    height: 100%;
    background-color: #edfbff;
    border-radius: 30px;
  }

  .search_button:hover {
    cursor: pointer;
  }
  /deep/ .cell {
    font-size: 16px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      padding: 0px;
      font-size: 18px;
      color: #2fb3ff;
    }
    .el-table__header tr,
    .el-table__header th {
      padding: 6.5px 0 !important;
    }
  }

  // /deep/ .el-table__header-wrapper {
  // 	.el-table td, .el-table th{
  // 		padding: 5px 0;
  // 		color: orange;
  // 	}
  // }
}

// .right {
// 	display: flex;
// 	width: 35%;
// 	justify-content: space-between;
// }
.export {
  width: 40px;
  height: 40px;
  background-image: url(~@/assets/images/public/public_upload.png);
  background-size: 100%;
  background-position: center;
}

.picker {
  height: 20vh;
  position: relative;

  .content {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
}

.export:hover {
  cursor: pointer;
}

.c-u-right {
  /deep/ .el-input__inner {
    // height: 30px;
    // line-height: 30px;
    border-radius: 15px;
  }

  .search {
    /deep/ .el-input__suffix {
      line-height: 28px;
      color: #2fb3ff;
      font-size: 16px;
      right: 10px;
      cursor: pointer;
    }
  }
}

.datepick /deep/ .el-input__inner {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: #edfbff;
  border: 0;
}

// .select /deep/ .el-input__inner {
// 	border-radius: 15px;
// }

// .pick /deep/ .el-date-editor{
// 	background-color: #edfbff;
// 	border-style: none;
// 	border-radius: 30px;
// }
// .pick /deep/ .el-range-input{
// 	background-color: #edfbff;
// }

.pick /deep/ .el-date-editor {
  border-style: none;
  // background-color: pink;
  padding: 0;
}

.pick /deep/ .el-range-input {
  height: 100%;
  border-radius: 30px;
  width: 45%;
  background-color: #edfbff;
}

.pick /deep/ .el-range-input:hover {
  cursor: pointer;
}

.pick /deep/ .el-range-separator {
  width: 30px;
  color: #c4e3f6;
}

.pick /deep/ .el-input__icon {
  display: none;
}
</style>
